<!-- OPCION 1: APERTURA MODO POPUP -->
<ng-container *ngIf="this.isPopup">
  <sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false" *ngIf="this.isPopup">
  </sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '90vh'}" styleClass="custombar1" *ngIf="this.isPopup">
    <ng-container *ngTemplateOutlet="templateBase"></ng-container>
  </p-scrollPanel>
</ng-container>
<!-- OPCION 2: APERTURA NORMAL (NO POPUP) -->
<ng-container *ngIf="!this.isPopup">
  <ng-container *ngTemplateOutlet="templateBase"></ng-container>
</ng-container>
<ng-template #templateBase>
  <div class="container-fluid  m-t-sm" [ngClass]="{'p-5 mt-5': showHeader}">
    <div *ngIf="isLoaded()">
      <div class="row">
        <div *ngIf="showHeader" class="row col-12">
          <div class="col-12 p-0">
            <dossierHeader title="{{'DossierInfo.sections.GENERAL_INFO.name' | translate}}"
              [projectId]="dossier.identifier" [titleIcon]="'fa fa-info'" [infoVisible]="!isPopup"></dossierHeader>
          </div>
        </div>
        <!-- 1. INFORMACION BASICA -->
        <div class="col-12 p-0" *ngIf="!otherComponentLoaded">
          <div class="col-12 float-left" [ngClass]="(isGraphicLoaded())?'col-md-4':'col-md-12'">
            <dl>
              <dt>{{ 'DossierBasicInfo.id.dossier' | translate }}</dt>
              <dd>{{ dossier.contractFolderId }}</dd>
              <ng-container *ngIf="dossierIdExternal">
                <dt>{{ 'DossierBasicInfo.id.external' | translate }}</dt>
                <dd>{{ dossierIdExternal }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.title">
                <dt>{{ 'DossierBasicInfo.title' | translate }}</dt>
                <dd>{{ dossier.title }}</dd>
              </ng-container>
              <dt>{{ 'DossierBasicInfo.contract.object' | translate }}</dt>
              <dd class="text-truncate-exp">{{ dossier.name }}</dd>
              <ng-container *ngIf="dossier?.organizationalUnit.name">
                <dt>{{ 'GenericDossier.organizationalUnit' | translate }}</dt>
                <dd>{{ dossier.organizationalUnit.name }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.startYear">
                <dt>{{ 'DossierBasicInfo.init.year' | translate }}</dt>
                <dd>{{ dossier.startYear }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.type?.description">
                <dt>{{ 'DossierBasicInfo.procedure' | translate }}</dt>
                <dd>{{ dossier.type.description }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.classification?.typeCode?.description">
                <dt>{{ 'DossierBasicInfo.tipoExpteId' | translate }}</dt>
                <dd>{{ dossier.classification.typeCode.description }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.phase?.description">
                <dt>{{ 'DossierBasicInfo.phase.text' | translate }}</dt>
                <dd>{{ dossier.phase.description }}</dd>
              </ng-container>
              <ng-container *ngIf="this.dossier?.status?.situation&&this.dossier.status.situation=='Cancelled'">
                <dt>{{ 'DossierDetail.situation.label' | translate }}</dt>
                <dd><span [ngClass]="getSituationClass()">{{ 'DossierDetail.situation.canceled' | translate }}</span>
                </dd>
              </ng-container>
              <ng-container *ngIf="dossier?.classification?.processingMode?.description">
                <dt>{{ 'DossierBasicInfo.process' | translate }}</dt>
                <dd>{{ dossier.classification.processingMode.description }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.classification?.urgencyCode?.description">
                <dt>{{ 'DossierBasicInfo.class' | translate }}</dt>
                <dd>{{ dossier.classification.urgencyCode.description }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.budget?.amountExcludingTaxes">
                <dt>{{ 'DossierBasicInfo.amount.tender.text' | translate }}</dt>
                <dd>{{ dossier.budget.amountExcludingTaxes | currency: 'EUR' }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.budget?.totalAmount">
                <dt>{{ 'DossierBasicInfo.amount.tender.taxes' | translate }}</dt>
                <dd>{{ dossier.budget.totalAmount | currency: 'EUR' }}</dd>
              </ng-container>
              <ng-container *ngIf="dossier?.budget?.estimatedAmount">
                <dt>{{ 'DossierBasicInfo.estimated.value' | translate }}</dt>
                <dd>{{ dossier.budget.estimatedAmount | currency: 'EUR' }}</dd>
              </ng-container>
              <ng-container *ngIf="urlPubExt && profilePubExt">
                <dt>{{ 'DossierBasicInfo.externalNotice.notice' | translate }} {{ profilePubExt }}</dt>
                <dd><a href="{{ urlPubExt }}" target="_blank">{{ 'DossierBasicInfo.externalNotice.link' | translate }}
                    {{ profilePubExt }}</a>
                </dd>
              </ng-container>
            </dl>
          </div>
          <ng-container *ngTemplateOutlet="graphicTemplate"></ng-container>
        </div>
        <!-- 2. INFORMACION DE REPLYCA -->
        <ng-container *ngIf="printReplycaTemplate()">
          <ng-container *ngTemplateOutlet="replycaTemplate"></ng-container>
        </ng-container>
      </div>
    </div>
    <!-- 3. INFORMACION DE OTROS EXPEDIENTES -->
    <div #otherContainer></div>
  </div>
</ng-template>
<!-- GRAFICO DE GRADO DE AVANCE -->
<ng-template #graphicTemplate>
  <dossierProgressGraph *ngIf="isProcurementProject()" [dossier]="dossier"></dossierProgressGraph>
  <frameworkAgreementProgressGraph *ngIf="isAMorSDA()" [dossier]="dossier"></frameworkAgreementProgressGraph>
  <dossierContractsProgressGraph [dossier]="dossier"></dossierContractsProgressGraph>
</ng-template>
<!-- INFORMACION REPLYCA -->
<ng-template #replycaTemplate>
  <!-- <ng-container *ngIf="replycaData ['LOTES']?.values">
    <tableComponent [titleKey]="'Expedientes relacionados'" [attributeValues]="replycaData ['LOTES'].values"
      [layoutClass]="'col-12 col-sm-12 col-lg-12'">
    </tableComponent>
  </ng-container> -->
  <ng-container *ngIf="replycaData ['RELACIONADOS']?.values">
    <ng-container *ngTemplateOutlet="relatedProjects"></ng-container>
  </ng-container>
  <ng-container *ngIf="replycaData ['LOTES']?.values">
    <!-- <div class="row m-t-md d-inline-block" *ngIf="replycaData ['LOTES']?.values"> -->
    <!-- <tableComponent [attributeId]="'REPLYCA_LOTES_EXP'" [attributeParams]='params'></tableComponent> -->
    <div class="col-12 p-0">
      <tableComponent [titleKey]="'Lotes del expediente'" [attributeValues]="replycaData ['LOTES'].values"
        [identifier]="replycaData ['LOTES'].identifier" [layoutClass]="'col-12 col-sm-12 col-lg-12'">
      </tableComponent>
    </div>
    <!-- </div> -->
  </ng-container>
  <ng-container *ngIf="replycaData ['ANUALIDADES']?.values">
    <!-- <div class="row m-t-md d-inline-block" *ngIf="replycaData ['ANUALIDADES']?.values"> -->
    <!-- <tableComponent [attributeId]="'REPLYCA_LOTES_EXP'" [attributeParams]='params'></tableComponent> -->
    <div class="col-12 p-0">
      <tableComponent [titleKey]="'Anualidades del expediente'" [attributeValues]="replycaData ['ANUALIDADES'].values"
        [layoutClass]="'col-12 col-sm-12 col-lg-12' ">
      </tableComponent>
    </div>
    <!-- </div> -->
  </ng-container>
</ng-template>
<!-- EXPEDIENTES RELACIONADOS -->
<ng-template #relatedProjects>
  <div class="col-12 col-sm-12 col-lg-12">
    <p-panel [toggleable]="true">
      <p-header>
        <i class="fa fa-link" aria-hidden="true"></i><span class="cif ml-2">{{ 'DossierBasicInfo.relatedDossiers.title' | translate }}</span>
      </p-header>
      <div class="alert alert-info col-12" role="alert"
        *ngIf="!replycaData['RELACIONADOS'] || replycaData['RELACIONADOS'] === 0">
        <span style="line-height: 2em;"><i class="fa fa-1-5x fa-info-circle mr-2" aria-hidden="true"></i>{{
          'General.noData' | translate }}</span>
      </div>
      <p-table [value]="replycaData['RELACIONADOS']" [rows]="25" [paginator]="true">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%;"> {{ 'DossierBasicInfo.relation' | translate
              }}
            </th>
            <th style="width: 20%;"> {{ 'General.project' |
              translate }} </th>
            <th style="width: 60%;"> {{ 'DossierBasicInfo.title' |
              translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-element>
          <tr style="cursor: pointer;" (click)="linkToRelated (element.columns['PROPUESTAID'].value)">
            <td field="RELACION"> {{element.columns['RELACION']?.value}} </td>
            <td field="EXPEDIENTEID"><span style="padding: 7px 0px;"> <i class="fa fa-lg fa fa-archive"
                  aria-hidden="true"></i></span> {{element.columns['EXPEDIENTEID']?.value}} </td>
            <td field="DESCRIPCION"> {{element.columns['DESCRIPCION']?.value}} </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr class="text-center">
            <td [attr.colspan]="3"> {{ 'General.noFilteredData' | translate }} </td>
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
</ng-template>